import { render } from "./CleanupConfirming.vue?vue&type=template&id=10e4c533"
import script from "./CleanupConfirming.vue?vue&type=script&lang=js"
export * from "./CleanupConfirming.vue?vue&type=script&lang=js"
script.render = render

export default script